module.exports = __webpack_public_path__ + "media/images/lb/049-63eaab62c2ea58a2a89033988f3e7a38.svg";